import graphql from "babel-plugin-relay/macro";
import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";

let query = graphql`
  query loadHyEventsRequestsQuery($orgId: ID!, $type: String!) {
    approvalRequests(orgId: $orgId, type: $type) {
      edges {
        node {
          id
          propertyId
          approved
          propertyName
          hyevent {
            id
            title
            publishAt
            status
          }
          createdAt
        }
      }
    }
  }
`;

export default (orgId) => {
  let variables = { orgId, type: "hyevents_my_approvals" };
  return fetchQuery(environment, query, variables);
};
